import * as React from 'react';
import { getAnimeRefId } from './anime/animeUtils';
var SymbolMapper = function (_a) {
    var ad = _a.ad, layoutId = _a.layoutId, symbolId = _a.symbolId, symbolMap = _a.symbolMap;
    var _b = getSymbolInfo(ad, symbolId, layoutId), symbol = _b.symbol, conditionalState = _b.conditionalState, hoverAnimation = _b.hoverAnimation;
    // check if the symbol should be shown
    if (isSymbolHidden(symbol, conditionalState)) {
        return null;
    }
    var DisplayNode = getDisplayNode(symbol.type, symbolMap);
    var timelineRefId = getAnimeRefId(symbolId);
    return (React.createElement(DisplayNode, { conditionalState: conditionalState, hoverAnimation: hoverAnimation, symbol: symbol, timelineRefId: timelineRefId }, symbol.children.map(function (childSymbolId) { return (React.createElement(SymbolMapper, { ad: ad, layoutId: layoutId, key: childSymbolId, symbolId: childSymbolId, symbolMap: symbolMap })); })));
};
var getSymbolInfo = function (ad, symbolId, layoutId) {
    var symbol = ad.symbols[symbolId];
    var conditionalStateId = symbolId + "_" + layoutId;
    var conditionalState = ad.conditionalStates[conditionalStateId];
    var timeline = ad.timelines[symbolId];
    var hoverAnimation = timeline &&
        timeline.animations.find(function (animation) { return animation.name === 'hover'; });
    return { conditionalState: conditionalState, hoverAnimation: hoverAnimation, symbol: symbol };
};
var getDisplayNode = function (symbolType, symbolMap) {
    // determine which node will be used
    var displayNode = symbolMap[symbolType];
    if (!displayNode) {
        throw new Error("Invalid symbol type: " + symbolType);
    }
    return displayNode;
};
/**
 * Check if symbol should be hidden.
 *
 * In Delivery: Symbol (not `stage`) does not have Conditional State for current Layout.
 * In Preview: Conditional State is marked invisible (except `disclaimer`).
 */
export var isSymbolHidden = function (symbol, conditionalState) {
    // ConditionalState was removed during publish.
    // The stage never has Conditional States.
    var emptyConditionalStateInDelivery = !conditionalState && symbol.type !== 'stage';
    // ConditionalState is marked as invisible (except 'disclaimer').
    var isInvisibleSymbol = !!conditionalState &&
        conditionalState.visible === false &&
        symbol.type !== 'disclaimer';
    return emptyConditionalStateInDelivery || isInvisibleSymbol;
};
export default SymbolMapper;
